module.exports = __webpack_public_path__ + "img/velosofi-logo-dark-gray.01d9d224.png";